import { ErrorMessage } from 'components/ErrorPages/ErrorMessage'

const PageError = () => <ErrorMessage errorType="general" />

export default PageError
